import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { markWelcomeSeen } from './utils/referralManager';
import './referral.css';

/**
 * Slim banner shown at top of dashboard when a referred user connects.
 * Dismissed by user or automatically after qualifying.
 */
function ReferralWelcomeBanner({ referrerAddress, walletAddress, onDismiss, onStartCleaning }) {
  const [visible, setVisible] = useState(true);

  const handleDismiss = () => {
    setVisible(false);
    if (walletAddress) markWelcomeSeen(walletAddress);
    onDismiss?.();
  };

  const shortAddr = (addr) => addr ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : '';

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="referral-welcome-banner"
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -16 }}
          transition={{ type: 'spring', damping: 24, stiffness: 280 }}
        >
          <div className="rwb-content">
            <span className="rwb-icon">🎉</span>
            <div className="rwb-text">
              <strong>Welcome to Distil!</strong>
              <span>
                You were invited by <code>{shortAddr(referrerAddress)}</code>.
                Earn <strong>50 $DISTIL</strong> by completing your first cleanup.
              </span>
            </div>
            <div className="rwb-actions">
              <button className="rwb-cta" onClick={() => { onStartCleaning?.(); handleDismiss(); }}>
                Start Cleaning →
              </button>
              <button className="rwb-dismiss" onClick={handleDismiss} title="Dismiss">✕</button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ReferralWelcomeBanner;
